import { Outlet, useLocation } from 'react-router-dom';
import { MadBoatNav } from '@/components/navigation';
import NoEnergyModal from '@/components/energy/NoEnergyModal';
import './AppLayout.css';

/**
 * AppLayout — Shared layout for all protected routes.
 * Renders the MadBoatNav bar and child route content via Outlet.
 */
export function AppLayout() {
  const location = useLocation();

  // Immersive routes where nav should be hidden
  const isNavHidden =
    location.pathname === '/diario' ||
    location.pathname.startsWith('/diario/');

  // Pricing view hides everything
  const isPricingView = location.search.includes('view=pricing');

  return (
    <div className="app-layout">
      <div className={`app-layout-content ${isNavHidden || isPricingView ? '' : 'has-nav'}`}>
        <Outlet />
      </div>
      {!isNavHidden && !isPricingView && <MadBoatNav />}
      <NoEnergyModal />
    </div>
  );
}
